@use '../../style/globals.scss' as *;

.Sidebar {
    transition: transform-origin 500ms $animation-bounce;
}
